export default __webpack_public_path__ + "static/media/dashboardOp.bea1de6c.svg";